<template>
  <b-nav
    vertical
    class="sub-menu section-checks"
  >
    <b-nav-item
      :id="isCompact ? 'pop-section-setup' : ''"
      v-testing="'selector'"
      v-b-toggle.statusCollapse-a
      class="selector sub-menu-title"
      @click="toggle"
    >
      <div
        v-testing="'section-settings'"
        class="icon-wrapper"
      >
        <slot name="icon">
          <i
            class="fal fa-cog"
            aria-hidden="true"
          />
        </slot>
      </div>
      <b-button class="blank-button">
        <span class="white">{{ title }} ({{ checkedCount }})</span>
      </b-button>
      <fa-icon
        class="arrow-menu mr-2"
        :icon="chevron"
      />
    </b-nav-item>
    <!--En este slot viene el popover de configurar secciones para que funcione-->
    <slot />
    <b-collapse id="statusCollapse-a">
      <b-nav
        v-if="!sidebarState"
        class="sub-menu-items"
        vertical
      >
        <ul class="pl-3">
          <li
            v-for="(section, indexSection) in sections"
            :key="section.id"
            class="py-2"
          >
            <b-form-checkbox
              :id="section.id.toString()"
              v-model="section.checked"
              v-testing="section.code"
              @change="sectionChanged(section, indexSection)"
            >
              <span>{{ section.name }}</span>
            </b-form-checkbox>
          </li>
        </ul>
      </b-nav>
    </b-collapse>
  </b-nav>
</template>

<script>
export default {
    name: 'SectionChecks',
    props: {
        title: { type: String, required: true },
        sections: { type: Array, required: true },
        isCompact: { type: Boolean, default: false },
        sidebarState: { type: Boolean, default: false }
    },
    data() {
        return {
            visible: false
        }
    },
    computed: {
        chevron() {
            return this.visible ? ['fal', 'chevron-up'] : ['fal', 'chevron-down']
        },
        checkedCount() {
            return this.sections.filter(section => section.checked).length
        }
    },
    methods: {
        toggle() {
            this.visible = !this.visible
        },
        sectionChanged(section, index) {
            this.$emit('sectionChanged', section)

            this.$set(this.sections, index, section)
        }
    }
}
</script>

<style scoped lang="scss">
  .blank-button{
    padding: 0;
    margin: 0;
    background: transparent;
    border: transparent;
  }
  .section-title{
    font-size: 1rem;
  }

  .section-list{
    list-style: none;
  }

  .section-checks ul{
    list-style: none;
  }

  .section-checks ul li{
    font-size: .9rem;
    margin-left: 2px;
    color: vt-color(white-light);
  }

  .section-checks ul li span{
    margin-left: 10px;
  }

  .arrow-menu{
    font-size: 0.7rem;
  }

  /*-- Título submenú--*/

  .selector{
    transition: 1s;
    border: 1px solid vt-color(white-light);
    border-radius: 3px;
    margin: 2px;
    height: 40px;
  }

  .selector:hover{
    transition: .3s;
    background: vt-color(primary);
    border: 1px solid vt-color(primary);
  }

  .selector:hover i{
    color: vt-color(white-light);
  }

  .selector span,
  .selector .arrow-menu,
  .selector i {
    transition: .3s;
  }

  .selector:hover span{
    color: vt-color(white-light);
  }

  .selector:hover .arrow-menu{
    color: vt-color(white-light);
  }

  .icon-wrapper {
    font-size: 1rem;
    width: 32px;
    color: vt-color(white-light);
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    > .svg-inline--fa {
      margin-left: unset !important;
    }

  }

  .sub-menu-title {
    font-weight: bold;
    svg:last-child { // the chevron
      margin-left: auto;
    }
    .nav-link:hover {
      color: vt-color(primary);
    }
    .nav-link {
      padding: {
        right: .5rem;
        left: .5rem;
        top: 0.1rem;
        bottom: 0.1rem;
      }
    }
  }

  .sub-menu-items {
      ::v-deep .nav-link {
      position: relative;
      padding: 0 1rem 0 3rem;
      &:hover {
        background-color: vt-color(light-primary);
      }
      &.active {
        color: vt-color(primary) !important;
        border-left:0.3rem solid vt-color(primary) !important;
        background: vt-color(light-primary) !important;
        &::before {
          content: "";
          position: absolute;
          height: 100%;
          width: 3px;
          left: -7px;
          background-color: vt-color(black);
        }
      }
    }
  }

  .sub-menu-items{
    background:vt-color(sidebar-childs-bg);
  }

  .nav-link span{
    font-size: 0.9rem;
  }

  @media (max-width: 1300px){
    .nav-link span{
      font-size: 0.9rem;
    }

    .icon-wrapper{
      font-size: 1.1rem;
    }

  }
</style>
